import { request4 } from '@/service/request4'

// 分页查询小票打印机
export function getPrinterPage(data) {
  return request4({
    url: '/printer/web/page',
    method: 'post',
    data
  })
}

// 新增小票打印机
export function createPrinter(data) {
  return request4({
    url: '/printer/web/create',
    method: 'post',
    data
  })
}

// 编辑小票打印机
export function editPrinter(data) {
  return request4({
    url: '/printer/web/edit',
    method: 'put',
    data
  })
}

// 删除小票打印机
export function deletePrinter(id) {
  return request4({
    url: `/printer/web/delete?id=${id}`,
    method: 'delete'
  })
}
